import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { apiErr } from "../../lib/apiErr";

const pick = (...v) => v.find((x) => x !== null && x !== undefined && x !== "");

// Mirrors backend quote(): base × (1+margin) × (1+PPN) ÷ usd_per_credit, margin/PPN chain component → service → provider → global.
export function calc(comp, svc, prov, g, qty) {
  const q = qty ?? comp.qty_basis;
  const margin = Number(pick(comp.margin_pct, svc.margin_pct, prov.margin_pct, g.margin_pct));
  const tax = Number(pick(comp.tax_pct, svc.tax_pct, prov.tax_pct, g.tax_pct));
  const base = (Number(comp.usd) * q) / Number(comp.qty_basis || 1);
  const sell = base * (1 + margin / 100) * (1 + tax / 100);
  const credits = sell / g.usd_per_credit;
  return { margin, tax, base, sell, credits };
}

export const fmt = (n, d = 4) => Number(n).toLocaleString("id-ID", { maximumFractionDigits: d });

export function useCatalog() {
  const [data, setData] = useState(null);
  const [draft, setDraft] = useState(null);
  const [busy, setBusy] = useState(false);
  // PUT/import responses omit globals/units/feature_map — merge so the page keeps them.
  const apply = (d) => { setData((prev) => ({ ...(prev || {}), ...d })); setDraft(structuredClone(d.catalog)); };
  const load = useCallback(() => api.get("/admin/pricing-catalog").then((r) => apply(r.data)).catch((e) => toast.error(apiErr(e, "Gagal memuat katalog"))), []);
  useEffect(() => { load(); }, [load]);
  const patch = (pi, si, ci, field, value) => setDraft((d) => {
    const nd = structuredClone(d);
    const p = nd.providers[pi];
    const target = si === null ? p : ci === null ? p.services[si] : p.services[si].components[ci];
    target[field] = value;
    return nd;
  });
  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/admin/pricing-catalog", draft); apply(r.data); toast.success("Katalog disimpan — langsung dipakai penagihan"); }
    catch (e) { toast.error(apiErr(e, "Gagal menyimpan katalog")); } finally { setBusy(false); }
  };
  const reset = () => setDraft(structuredClone(data.catalog));
  const dirty = !!data && JSON.stringify(data.catalog) !== JSON.stringify(draft);
  return { data, draft, patch, save, reset, busy, dirty, apply };
}
